export const common = {
  edubox: 'EDUbox',
  talk: 'Spreekbeurt',
  start: 'Start',
  stop: 'Stop',
  previous: 'Vorige',
  next: 'Volgende',
  error: {
    noConnection: 'Kan geen verbinding maken met de server',
    invalidRoom: 'Ongeldige kamer',
  },
};
